import HBIcon from "@/components/HBIcon";
import { Collapse } from "antd";
import { useState } from "react";
import { When } from "react-if";
import styles from "./index.module.less";
const { Panel } = Collapse;
interface Iprops {
  question: {
    title: string;
    content: string;
  }[];
  questionTitle?: string | JSX.Element;
  questionMoreText?: string;
  questionMoreLink?: string;
  hideQuestionMore?: boolean;
}
export default function Question({
  question,
  questionTitle = "常见问题",
  hideQuestionMore = false,
  questionMoreLink = "https://support.qq.com/products/30852/faqs-more/#classifyId=87404",
  questionMoreText = "看更多问题",
}: Iprops) {
  const [activeKey, setActiveKey] = useState([]);
  const onChange = (activeKey) => {
    setActiveKey(activeKey);
  };
  const onToggle = (evt, index) => {
    // 点击a标签的时候不收起
    if (evt?.target?.nodeName === "A") {
      return;
    }
    const contain = activeKey.includes(`${index}`);
    if (contain) {
      setActiveKey(activeKey.filter((key) => key !== `${index}`));
    } else {
      setActiveKey([...activeKey, `${index}`]);
    }
  };
  return (
    <div className={styles.questionContent}>
      <header>{questionTitle}</header>
      <Collapse
        className={styles.collapse}
        destroyInactivePanel={true}
        ghost={true}
        activeKey={activeKey}
        onChange={onChange}
      >
        {question?.map((item, index) => (
          <Panel
            header={item?.title}
            showArrow={false}
            extra={<HBIcon className={styles.arrow} type="ic_arrow_down" />}
            key={`${index}`}
          >
            <div
              className={styles.content}
              dangerouslySetInnerHTML={{ __html: item?.content }}
              onClick={(evt) => onToggle(evt, index)}
            ></div>
          </Panel>
        ))}
      </Collapse>
      <When condition={!hideQuestionMore}>
        <div className={styles.more}>
          <a
            className={styles.link}
            href={questionMoreLink}
            target="_blank"
            rel="noreferrer"
          >
            <div className={styles.text}>{questionMoreText}</div>
            <HBIcon className={styles.icon} type="ic_chevron_right" />
          </a>
        </div>
      </When>
    </div>
  );
}
